/**
 * Factory que crea un guard de permisos basado en los grupos del usuario.
 * Si el usuario no pertenece a ninguno de los `permissions` indicados,
 * se le redirige a la ruta `redirectTo`.
 *
 * @param {string[]} permissions - Lista de grupos permitidos (basta con tener uno).
 * @param {string} [redirectTo='pbxCloud'] - Nombre de ruta a la que redirigir si no cumple.
 * @returns {Function} guard compatible con `beforeEnter` de vue-router.
 */
import { encryptStorage } from '@/utils/storage.js';

export const hasAnyPermissionGuard = (permissions, redirectTo = 'pbxCloud') => {
  return (to, from, next) => {
    const user = encryptStorage.getItem('user');
    const groups = user?.groups || [];
    const hasAccess = permissions.some((p) => groups.includes(p));

    if (hasAccess) {
      next();
    } else {
      console.log(' --- USUARIO SIN PERMISOS PARA ESTA RUTA --- ');
      next({ name: redirectTo });
    }
  };
};

export default hasAnyPermissionGuard;
